/**
 * Start inline video from a tap/click. iOS only unlocks playback for code that runs
 * synchronously in the user gesture stack — not inside promise .catch() microtasks.
 *
 * Strategy: call play() once while muted (allowed), then try to unmute immediately in the
 * same synchronous turn. If audio stays muted, the user can use native controls after onPlay.
 */
export function playVideoFromUserGesture(video) {
  if (!video || typeof video.play !== 'function') return;

  try {
    video.playsInline = true;
  } catch (_) {
    // ignore
  }

  const prevMuted = video.muted;

  try {
    video.muted = true;
    video.play();
  } catch (_) {
    try {
      video.muted = prevMuted;
    } catch (_) {
      // ignore
    }
    return;
  }

  try {
    video.muted = prevMuted;
  } catch (_) {
    // ignore
  }

  if (video.muted === false) {
    try {
      video.play();
    } catch (_) {
      try {
        video.muted = true;
        video.play();
      } catch (_) {
        // ignore
      }
    }
  }
}

/**
 * Keep HTMLMediaElement.play() tied to a real user activation (Safari / iOS).
 * Avoids touchend preventDefault breaking button activation and covers Pointer + Touch + keyboard.
 */
export function playGateInteractionHandlers(onFire) {
  return {
    onPointerDownCapture(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      e.stopPropagation();
      onFire(e);
    },
    onTouchStartCapture(e) {
      e.stopPropagation();
      onFire(e);
    },
    onKeyDown(e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      onFire(e);
    },
  };
}
